__turbopack_context__.v({
  "UiBannerCard__icon": "cards-module__auXAXq__UiBannerCard__icon",
  "UiMenuCard__icon": "cards-module__auXAXq__UiMenuCard__icon",
});
